/** Visible screen/nav title for the audit CSV export route (/audit-export). */
export const REPORT_EXPORT_SCREEN_LABEL = "Report Export";
